var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import ReadingItemWordSpan from "../ReadingItemWordSpan";
import { useUserPreferences,
// @ts-ignore
 } from "@projectdiction/common-react";
import { splitTextIntoTokens, // @ts-ignore
 } from "@projectdiction/api-helper";
export default function ParagraphHiglightPOS(_a) {
    var text = _a.text, wordClicked = _a.wordClicked;
    var _b = React.useState([]), tokens = _b[0], setTokens = _b[1];
    var userPreferences = useUserPreferences();
    React.useEffect(function () {
        if (!userPreferences)
            return;
        function process() {
            return __awaiter(this, void 0, void 0, function () {
                var tokens;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, splitTextIntoTokens(text, userPreferences.languages.studyLanguage)];
                        case 1:
                            tokens = _a.sent();
                            setTokens(tokens.tokens);
                            return [2 /*return*/];
                    }
                });
            });
        }
        process();
    }, [text, userPreferences]);
    return (_jsx(_Fragment, { children: tokens.map(function (token, index) {
            var color = "white";
            if (token.pos === "ADJ") {
                color = "red";
            }
            if (token.pos === "ADP") {
                color = "indigo";
            }
            if (token.pos === "ADV") {
                color = "purple";
            }
            if (token.pos === "AUX") {
                color = "green";
            }
            if (token.pos === "CCONJ") {
                color = "pink";
            }
            if (token.pos === "DET") {
                color = "gray";
            }
            if (token.pos === "INTJ") {
                color = "yellow";
            }
            if (token.pos === "NOUN") {
                color = "yellow";
            }
            if (token.pos === "NUM") {
                color = "blue";
            }
            if (token.pos === "PART") {
                color = "indigo";
            }
            if (token.pos === "PRON") {
                color = "green";
            }
            if (token.pos === "PROPN") {
                color = "green";
            }
            if (token.pos === "SCONJ") {
                color = "orange";
            }
            if (token.pos === "SYM") {
                color = "pink";
            }
            if (token.pos === "VERB") {
                color = "blue";
            }
            if (token.pos === "X") {
                color = "yellow";
            }
            var word = (_jsx("b", __assign({ className: "bg-".concat(color, "-200") }, { children: token.text }), index));
            return (_jsx(ReadingItemWordSpan, { word: word, wordClicked: wordClicked }, index));
        }) }));
}
